import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";
import { LoaderService } from "../service/loader.service";
import { HttpClient } from "@angular/common/http";
import { api } from "../../environments/environment";

@Component({
  selector: "app-import-notice-csv",
  template: ``,
  styles: [],
  standalone: false,
})
export class DwCallCSVComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;

  constructor(private host: ElementRef<HTMLElement>,private message:Message,private rest:RestService,private loader:LoaderService,private http:HttpClient) {}

  ngOnInit(): void {
    // let myInput = document.getElementById('input-upload-notice-csv')
    // if(myInput){
    //   myInput.click()
    // }
    // setTimeout(() => {
    //   this.autoDestory()
    // }, 1);
    this.dwX()
  }

  dwX() {
    this.loader.on()
    let options = {
      page: this.fatherContaierRef.currentPage,
      filters: [
        ...this.fatherContaierRef.filtersList.map((filter: any) => {
          return {
            s: filter.s,
            v: filter.v,
            o: filter.o,
          };
        }),
        ...this.fatherContaierRef.baseFiltersList,
      ],
    };
    
    this.http.get(`${api.baseUrl}/booking/export?options=${JSON.stringify(options)}`, {
      responseType: "blob",
      headers: {
        Authorization: `${api.prefixAuthorization} ${localStorage.getItem(
          'token'
        )}`,
      },
    }).subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "export.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.loader.off(true);
      });
  }

  // uploadFile(event:any){
  //   if(event?.target?.files ){
  //     if(event?.target.files[0].type.includes('/csv')){
  //       let myForm = new FormData()
  //       myForm.append('file',event?.target.files[0] )
  //       this.rest.post('/csv/upload',myForm).subscribe({
  //         next:(value)=> {
  //           this.message.showMessage("Bando importato con successo",'success')
  //           this.fatherContaierRef.getTableData();
  //         },
  //         error:(value)=> {
  //           this.message.showMessage("Errore nell'importazione del bando",'error')
  //         },
  //       })
  //     }else{
  //       this.message.showMessage('Puoi caricare solo csv','error')
  //     }
  //   }
  // }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
